import clip from 'text-clipper'

/* Truncate html via the `clip` function */
export function useHtmlTruncate(htmlString: string, maxLength = 160) {
  return clip(htmlString, maxLength, {
    html: true,
    maxLines: 3,
    stripTags: ['img', 'svg', 'script'],
  })
}
